import { render, staticRenderFns } from "./rateBox.vue?vue&type=template&id=0dedf7ea&scoped=true&"
import script from "./rateBox.vue?vue&type=script&lang=js&"
export * from "./rateBox.vue?vue&type=script&lang=js&"
import style0 from "./rateBox.vue?vue&type=style&index=0&id=0dedf7ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dedf7ea",
  null
  
)

export default component.exports